import {
  get,
  post,
  error
} from '@/api/common.js'

function getLeftMenu(path, that) {
  get(path).then(function(Response) {
    that.itemMenu = Response.data;
  }, function(Response) {
    error(Response);
  });
}

function getItem(path, that, type) {
  get(path).then(function(Response) {
    that.itemList = Response.data;
    if (type == "1" && that.itemList.length == 0) {
      that.isShow = true;
    }
  }, function(Response) {
    error(Response);
  });
}

function getItemDesc(path, that, type) {
  get(path).then(function(Response) {
      if (type == "1") {
        that.$data.myform.name = Response.data.name;
        that.$data.dropdown = Response.data.type;
        that.$data.myform.nid = Response.data.nid;
        that.$data.myform.content = Response.data.content;
        that.$data.myform.itemsId = Response.data.itemsId + ",";
        that.$data.myform.paramsId = Response.data.paramsId + ",";
        var arr = Response.data.itemsList;
        that.$data.fileList1 = [];
        for (var a in arr) {
          var myurl = arr[a].imageName;
          var arr2 = myurl.split("/");
          var myname = arr2[arr2.length - 1];
          that.$data.fileList1.push({
            name: myname,
            url: myurl,
            id: arr[a].id,
          });
        }
        arr = Response.data.paramsList;
        that.$data.fileList2 = [];
        for (var a in arr) {
          var myurl = arr[a].imageName;
          var arr2 = myurl.split("/");
          var myname = arr2[arr2.length - 1];
          that.$data.fileList2.push({
            name: myname,
            url: myurl,
            id: arr[a].id,
          });
        }
      } else if (type == "2") {
        that.$data.name = Response.data.name;
        var temp = Response.data.content.replace(/\b/g, "&nbsp;");
        temp = "<p style='text-indent: 2em;'>" + temp.replace(/\n/g, "</p><p style='text-indent: 2em;'>") + "</p>"
        that.$data.content = temp.replace(/<p style='text-indent: 2em;'>主要应用领域/g, "<p><b>主要应用领域</b>").replace(
          /<p style='text-indent: 2em;'>优点/g, "<p><b>优点</b>");
        var arr = Response.data.itemsList;
        for (var a = 0; a < arr.length; a++) {
          arr[a].spansize = "";
          if (arr[a].showName.indexOf("@") != -1) {
            arr[a].spansize = "float:left"
          }
          arr[a].showName = arr[a].showName.replace(/@/g, "&nbsp;");
          }
          that.$data.itemsList = arr;
          that.$data.paramsList = Response.data.paramsList;
        }
      },
      function(Response) {
        error(Response);
      });
  }

  export {
    getLeftMenu,
    getItem,
    getItemDesc,
  }



// WEBPACK FOOTER //
// ./src/api/item.js